var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_66_1029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.76292 0.926912L3.58017 24.1754C3.59352 24.3461 3.6575 24.5089 3.76393 24.643C3.87036 24.7771 4.01439 24.8763 4.17758 24.9281L13.74 27.9598C13.9091 28.0134 14.0907 28.0134 14.2598 27.9598L23.8222 24.9281C23.9854 24.8763 24.1294 24.7771 24.2359 24.643C24.3423 24.5089 24.4063 24.3461 24.4196 24.1754L26.2369 0.926912C26.276 0.427081 25.8809 0 25.3796 0H2.62024C2.11892 0 1.7239 0.427081 1.76292 0.926912ZM21.5767 8.14015H9.73325L10.0907 11.4361H21.3191L20.5845 20.8325L13.9999 22.9201L7.41532 20.8325L7.03158 15.9234H10.4877V18.3314L14.0923 19.2988L17.6753 18.3314L17.9533 14.4938H6.91981L6.18729 5.12207H21.8125L21.5767 8.14015Z",
    fill: "#FC490B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_1029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.865c67c7befefdd31b5b073ab6f16a4d.svg";
export { ForwardRef as ReactComponent };